import { render, staticRenderFns } from "./viewForm.vue?vue&type=template&id=2fdbb2de&scoped=true"
import script from "./viewForm.vue?vue&type=script&lang=js"
export * from "./viewForm.vue?vue&type=script&lang=js"
import style0 from "./viewForm.vue?vue&type=style&index=0&id=2fdbb2de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbb2de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdbb2de')) {
      api.createRecord('2fdbb2de', component.options)
    } else {
      api.reload('2fdbb2de', component.options)
    }
    module.hot.accept("./viewForm.vue?vue&type=template&id=2fdbb2de&scoped=true", function () {
      api.rerender('2fdbb2de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/spu/components/viewForm.vue"
export default component.exports